// All static strings, config, and magic numbers for ChatJourney feature
export const MAX_IMAGE_SIZE_MB = 5;
export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];
export const MAX_IMAGE_WIDTH = 400;
export const MAX_IMAGE_HEIGHT = 400;
export const IMAGE_OUTPUT_TYPE = "image/webp";
export const IMAGE_OUTPUT_QUALITY = 0.7;
export const QUESTION_MAX_LENGTH = 50;
export const RESPONSE_MAX_LENGTH = 300;
export const EDITOR_HEIGHT = "200px";
export const EDITOR_HEADER_BUTTONS = [
  { className: "ql-bold", ariaLabel: "Bold" },
  { className: "ql-italic", ariaLabel: "Italic" },
  { className: "ql-underline", ariaLabel: "Underline" },
  { className: "ql-image", ariaLabel: "Image" }
];
export const DIALOG_HEADER = "Message Editor";
export const DIALOG_WIDTH = "80vw";
export const DIALOG_CLASS = "node-dialog";
export const ERROR_IMAGE_SIZE = "Image size should be less than 5MB";
export const ERROR_IMAGE_TYPE = "Please upload a valid image file (JPEG, PNG, GIF, or WebP)";
export const ERROR_TITLE = "Error";
export const ERROR_LIFE = 3000;
export const SAVE_LABEL = "Save";
export const CANCEL_LABEL = "Cancel";
export const SAVE_ICON = "pi pi-check";
export const PRIMARY_BUTTON_CLASS = "p-button-primary";
export const TEXT_BUTTON_CLASS = "p-button-text";
export const CHAR_COUNTER_CLASS = "char-counter";
export const P_INVALID_CLASS = "p-invalid";
export const WELCOMING_MESSAGE_LABEL = "Welcoming Message (max 50 characters):";
export const CUSTOMER_QUESTION_LABEL = "Customer Question (max 50 characters):";
export const BOT_RESPONSE_LABEL = "Bot Response (max 300 characters):";
export const MESSAGE_EXCEED_LABEL = "Message cannot exceed 50 characters";
export const QUESTION_EXCEED_LABEL = "Question cannot exceed 50 characters";
export const RESPONSE_EXCEED_LABEL = "Bot response cannot exceed 300 characters";
